(function($) {
    /* Global Ajax method */
    window.sendAjaxRequest = function(URL, succesAction, data) {
        $.ajax({
            url: URL,
            data: data ? data : "",
            type: "POST",
            dataType: "html",
            success: succesAction
        });
    };

    /* Notification overlay functionality */
    window.isPdppage = false;
    window.initNotification = function() {
        $('a.wcs-preorder-link').unbind('click').bind('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            if ($('#wcs-pageName').length === 0)
                return;
            var pageName = $('#wcs-pageName')[0].value;
            if ($(this).data('pdp')) {
                isPdppage = true;
            } else {
                isPdppage = false;
            }

            var data = "";
            var catEntryId, storeID, catalogID, langId, emailSRC, metaTitle, sku, partNumber, productId,
                    altText, title, categoryTypeForEmail, prodCatType, price, clearancePrice, configurationId, name, isPreOrder;
            if (pageName === "productDisplayPage") {
                catEntryId = $('#catEntryId').val();
                storeID = $("#storeId").val();
                catalogID = $("#catalogId").val();
                langId = $("#langId").val();
                emailSRC = $("#emailSRC").val();
                metaTitle = $('#wcs-productdescval').text();
                sku = $('span#wcs-resolvedskuvalForEmailShare').text();
                partNumber = $('#partNumber').val();
                productId = $('#productId').val();
                altText = $('#altText').val();
                title = $('#title').val();
                categoryTypeForEmail = $('#categoryTypeForEmail').val();
                prodCatType = $('#prodCatTypePDP').val();
                isPreOrder = $('#isPreOrder').val();
                if ($('#isClearance').length > 0 && $('#isClearance').val() == "true") {
                    price = $.trim($('div.wcs-price-clearance>div.wcs-clear-sp-price').html());
                    clearancePrice = $.trim($('div.wcs-price-clearance>div.wcs-clear-strike-price>strike').html());
                } else {
                    price = $('span#wcs-productprice').html();
                }
                configurationId = $('#configurationIdSocial').val();
                name = $('span#wcs-productdescval').html();
                data = {"storeId": storeID, "catalogId": catalogID, "catEntryId": catEntryId, "langId": langId, "emailSRC": emailSRC,
                    "metaTitle": metaTitle, "sku": sku, "productId": productId, "partNumber": partNumber, "altText": altText, "title": title, "categoryTypeForEmail": categoryTypeForEmail,
                    "prodCatType": prodCatType, "price": price, "name": name, "configurationId": configurationId, "clearancePrice": clearancePrice, "isPreOrder": isPreOrder};

            } else if (pageName === "QuickViewInfoPage") {

                catEntryId = $('#catEntryId').val();
                storeID = $("#storeId").val();
                catalogID = $("#catalogId").val();
                langId = $("#langId").val();
                emailSRC = $("#emailSRC").val();
                metaTitle = $('.wcs-product-description h6').text();
                sku = $('#skuEmailAvail').val();
                partNumber = $('#partNumber').val();
                productId = $('#productId').val();
                altText = $('#altText').val();
                title = $('#title').val();
                categoryTypeForEmail = $('#categoryTypeForEmail').val();
                prodCatType = $('#prodCatTypePDP').val();
                isPreOrder = $('#isPreOrder').val();

                if ($('#isClearance').length > 0 && $('#isClearance').val() == "true") {
                    price = $.trim($('div.wcs-price-clearance>div.wcs-clear-sp-price').html());
                    clearancePrice = $.trim($('div.wcs-price-clearance>div.wcs-clear-strike-price>strike').html());
                } else {
                    price = $.trim($('#item_price span#wcs-offerPrice').html());
                    if(null=== price || price === ""){
                    	price = $.trim($('#item_price span.wcs-offerPrice').html());
                    }
                }
                configurationId = $('#configurationIdSocial').val();
                name = $('.wcs-product-description h6').html();
                data = {"storeId": storeID, "catalogId": catalogID, "catEntryId": catEntryId, "langId": langId, "emailSRC": emailSRC,
                    "metaTitle": metaTitle, "sku": sku, "productId": productId, "partNumber": partNumber, "altText": altText, "title": title, "categoryTypeForEmail": categoryTypeForEmail,
                    "prodCatType": prodCatType, "price": price, "name": name, "configurationId": configurationId, "clearancePrice": clearancePrice, "isPreOrder": isPreOrder};
            }

            sendAjaxRequest('PreOrderRemindMeEmailView', appendNotificationData, data);
        });
    };
    window.appendNotificationData = function(data) {
        $('#wcs-preorder-emial-pop').remove();
        $('body').append(data);
        display_Modal_1('wcs-preorder-emial-pop');
        display_center_1($('#wcs-preorder-emial-pop'));
        closeNotification();
        //custom_label();
        //overAllFormValidation();
		window.forms = forms.add($('#wcs-preorder-email-form'));
		validateForms(forms);
        validateEmail();
        submitNotification();
        /**Register close event for popup**/
        $("#wcs-preorder-emial-pop .wcs-close-btn").off("click").on("click", function(e){
              $(e.target).closest(".wcs-quick-buy-lightbox").hide();
              $(".wcs-fadeout-full").css("height","0px");
        });
    };
    window.appendNotificationConfirmMsg = function(data) {
        var that = $('#preorder_notify_btn');
        $('.wcs-notify-container').hide();
        $(that).parents('.wcs-pop-container').find('.wcs-thankyou-pop').remove();
        $(that).parents('.wcs-pop-container').append(data);
        display_center_1($(that).parents('.wcs-pop-container'));
        closeNotification();
    };
    window.submitNotification = function() {
        $('#preorder_notify_btn').off('click').on('click', function(e) {
		
			if($('#wcs-preorder-email-form').h5Validate('allValid')){
			
			
				var data = "";
				e.stopPropagation();
				e.preventDefault();
				var catEntryId = $('#catEntryIdVal').val();
				var storeID = $("#storeId").val();
				var catalogID = $("#catalogId").val();
				var langId = $("#langId").val();
				var emailSRC = $("#emailSRCVal").val();
				var metaTitle = $('#metaTitleVal').val();
				var sku = $('#skuVal').val();
				var partNumber = $('#partNumberVal').val();
				var productId = $('#productIdVal').val();
				var altText = $('#altText').val();
				var title = $('#title').val();
				var viewName = $('#preorderviewname').val();
				var privacyPolicy;
				if ($('#remindviaemail').is(":checked") || $('#remindviaemail').parent().hasClass('wcs-c-on')){
					privacyPolicy = "on";
				}else{
					privacyPolicy = "off";
				}
				var checkbox = $('#checkboxID').val();
				var name = $('#nameVal').val();
				var configurationId = $('#configurationIdVal').val();
				var price = $('#priceVal').val();
				var URL = $('#preorderemail').val();
				var emailAddress = $('#preorderemailAddress').val();
				var clearancePrice = $('#clearancePriceVal').val();
				var isPreOrder = $('#isPreOrder').val();
				var roxSet = $('#roxSet_1').val();
            var hashedEmail =calcMD5(emailAddress);
            //Create cookie to set hashed email for analytics
            document.cookie = "tealium_data_user_emailMd5="+hashedEmail+";path=/;";
            
				data = {"storeId": storeID, "catalogId": catalogID, "catEntryId": catEntryId, "langId": langId, "emailSRC": emailSRC, "URL": URL,
					    "metaTitle": metaTitle, "sku": sku, "productId": productId, "partNumber": partNumber, "altText": altText, "title": title,
					   "price": price, "checkbox": checkbox, "privacyPolicy": privacyPolicy, "emailAddress": emailAddress, "viewName": viewName, "name": name, "configurationId": configurationId, "clearancePrice": clearancePrice,
					 "isPreOrder": isPreOrder, "roxSet_1":roxSet};
				sendAjaxRequest('SendPreOrderEmail', submitNotifyController, data); 
				
			}
        });
    };

    window.submitNotifyController = function() {
        var emailAddress = $('#preorderemailAddress').val();
        var storeId = $('#storeId').val();
        var langId = $('#langId').val();

        var data = {};
        data.emailAddress = emailAddress;
        data.storeId = storeId;
        data.langId = langId;

        sendAjaxRequest('PreOrderRemindMeSuccessEmailView', appendNotificationConfirmMsg, data);

    };

    window.closeNotification = function() {
        $("#wcs-preorder-emial-pop .wcs-close-btn, #wcs-preorder-emial-pop a.wcs-myOrder-status-link, #wcs-preorder-emial-pop a.wcs_close_lightBox").off('click').on('click', function(e) {
            if (isPdppage || ($("#shopCartPage") && $("#shopCartPage").length > 0 && $("#shopCartPage").val() == "ShopCart")) {
                $('.wcs-fadeout-full').removeAttr('style');
                $('.wcs-quick-buy-lightbox').hide();
            }
            else {
                $('#wcs-preorder-emial-pop').hide();
                if(window.isROX == "true" || ($("#isRoxEnabled").length>0 && $("#isRoxEnabled").val() === "true")) $('#D_QuickView_Prod').removeClass('wcs-hidden').show();
                else $('#D_QuickView').removeClass('wcs-hidden').show();
                $(".wcs-fadeout-full").css("height","3000px");
            }
            e.stopPropagation();
            e.preventDefault();

        });
    };
    //For MD5 encryption of emailId field in preOrder popup-Analytics start
    var hex_chr = "0123456789abcdef";
    function rhex(num)
    {
      str = "";
      for(j = 0; j <= 3; j++)
        str += hex_chr.charAt((num >> (j * 8 + 4)) & 0x0F) +
               hex_chr.charAt((num >> (j * 8)) & 0x0F);
      return str;
    }

    /*
     * Convert a string to a sequence of 16-word blocks, stored as an array.
     * Append padding bits and the length, as described in the MD5 standard.
     */
    function str2blks_MD5(str)
    {
      nblk = ((str.length + 8) >> 6) + 1;
      blks = new Array(nblk * 16);
      for(i = 0; i < nblk * 16; i++) blks[i] = 0;
      for(i = 0; i < str.length; i++)
        blks[i >> 2] |= str.charCodeAt(i) << ((i % 4) * 8);
      blks[i >> 2] |= 0x80 << ((i % 4) * 8);
      blks[nblk * 16 - 2] = str.length * 8;
      return blks;
    }

    /*
     * Add integers, wrapping at 2^32. This uses 16-bit operations internally 
     * to work around bugs in some JS interpreters.
     */
    function add(x, y)
    {
      var lsw = (x & 0xFFFF) + (y & 0xFFFF);
      var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
      return (msw << 16) | (lsw & 0xFFFF);
    }

    /*
     * Bitwise rotate a 32-bit number to the left
     */
    function rol(num, cnt)
    {
      return (num << cnt) | (num >>> (32 - cnt));
    }

    /*
     * These functions implement the basic operation for each round of the
     * algorithm.
     */
    function cmn(q, a, b, x, s, t)
    {
      return add(rol(add(add(a, q), add(x, t)), s), b);
    }
    function ff(a, b, c, d, x, s, t)
    {
      return cmn((b & c) | ((~b) & d), a, b, x, s, t);
    }
    function gg(a, b, c, d, x, s, t)
    {
      return cmn((b & d) | (c & (~d)), a, b, x, s, t);
    }
    function hh(a, b, c, d, x, s, t)
    {
      return cmn(b ^ c ^ d, a, b, x, s, t);
    }
    function ii(a, b, c, d, x, s, t)
    {
      return cmn(c ^ (b | (~d)), a, b, x, s, t);
    }

    /*
     * Take a string and return the hex representation of its MD5.
     */
    function calcMD5(str)
    {
      x = str2blks_MD5(str);
      a =  1732584193;
      b = -271733879;
      c = -1732584194;
      d =  271733878;

      for(i = 0; i < x.length; i += 16)
      {
        olda = a;
        oldb = b;
        oldc = c;
        oldd = d;

        a = ff(a, b, c, d, x[i+ 0], 7 , -680876936);
        d = ff(d, a, b, c, x[i+ 1], 12, -389564586);
        c = ff(c, d, a, b, x[i+ 2], 17,  606105819);
        b = ff(b, c, d, a, x[i+ 3], 22, -1044525330);
        a = ff(a, b, c, d, x[i+ 4], 7 , -176418897);
        d = ff(d, a, b, c, x[i+ 5], 12,  1200080426);
        c = ff(c, d, a, b, x[i+ 6], 17, -1473231341);
        b = ff(b, c, d, a, x[i+ 7], 22, -45705983);
        a = ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
        d = ff(d, a, b, c, x[i+ 9], 12, -1958414417);
        c = ff(c, d, a, b, x[i+10], 17, -42063);
        b = ff(b, c, d, a, x[i+11], 22, -1990404162);
        a = ff(a, b, c, d, x[i+12], 7 ,  1804603682);
        d = ff(d, a, b, c, x[i+13], 12, -40341101);
        c = ff(c, d, a, b, x[i+14], 17, -1502002290);
        b = ff(b, c, d, a, x[i+15], 22,  1236535329);    

        a = gg(a, b, c, d, x[i+ 1], 5 , -165796510);
        d = gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
        c = gg(c, d, a, b, x[i+11], 14,  643717713);
        b = gg(b, c, d, a, x[i+ 0], 20, -373897302);
        a = gg(a, b, c, d, x[i+ 5], 5 , -701558691);
        d = gg(d, a, b, c, x[i+10], 9 ,  38016083);
        c = gg(c, d, a, b, x[i+15], 14, -660478335);
        b = gg(b, c, d, a, x[i+ 4], 20, -405537848);
        a = gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
        d = gg(d, a, b, c, x[i+14], 9 , -1019803690);
        c = gg(c, d, a, b, x[i+ 3], 14, -187363961);
        b = gg(b, c, d, a, x[i+ 8], 20,  1163531501);
        a = gg(a, b, c, d, x[i+13], 5 , -1444681467);
        d = gg(d, a, b, c, x[i+ 2], 9 , -51403784);
        c = gg(c, d, a, b, x[i+ 7], 14,  1735328473);
        b = gg(b, c, d, a, x[i+12], 20, -1926607734);
        
        a = hh(a, b, c, d, x[i+ 5], 4 , -378558);
        d = hh(d, a, b, c, x[i+ 8], 11, -2022574463);
        c = hh(c, d, a, b, x[i+11], 16,  1839030562);
        b = hh(b, c, d, a, x[i+14], 23, -35309556);
        a = hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
        d = hh(d, a, b, c, x[i+ 4], 11,  1272893353);
        c = hh(c, d, a, b, x[i+ 7], 16, -155497632);
        b = hh(b, c, d, a, x[i+10], 23, -1094730640);
        a = hh(a, b, c, d, x[i+13], 4 ,  681279174);
        d = hh(d, a, b, c, x[i+ 0], 11, -358537222);
        c = hh(c, d, a, b, x[i+ 3], 16, -722521979);
        b = hh(b, c, d, a, x[i+ 6], 23,  76029189);
        a = hh(a, b, c, d, x[i+ 9], 4 , -640364487);
        d = hh(d, a, b, c, x[i+12], 11, -421815835);
        c = hh(c, d, a, b, x[i+15], 16,  530742520);
        b = hh(b, c, d, a, x[i+ 2], 23, -995338651);

        a = ii(a, b, c, d, x[i+ 0], 6 , -198630844);
        d = ii(d, a, b, c, x[i+ 7], 10,  1126891415);
        c = ii(c, d, a, b, x[i+14], 15, -1416354905);
        b = ii(b, c, d, a, x[i+ 5], 21, -57434055);
        a = ii(a, b, c, d, x[i+12], 6 ,  1700485571);
        d = ii(d, a, b, c, x[i+ 3], 10, -1894986606);
        c = ii(c, d, a, b, x[i+10], 15, -1051523);
        b = ii(b, c, d, a, x[i+ 1], 21, -2054922799);
        a = ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
        d = ii(d, a, b, c, x[i+15], 10, -30611744);
        c = ii(c, d, a, b, x[i+ 6], 15, -1560198380);
        b = ii(b, c, d, a, x[i+13], 21,  1309151649);
        a = ii(a, b, c, d, x[i+ 4], 6 , -145523070);
        d = ii(d, a, b, c, x[i+11], 10, -1120210379);
        c = ii(c, d, a, b, x[i+ 2], 15,  718787259);
        b = ii(b, c, d, a, x[i+ 9], 21, -343485551);

        a = add(a, olda);
        b = add(b, oldb);
        c = add(c, oldc);
        d = add(d, oldd);
      }
      return rhex(a) + rhex(b) + rhex(c) + rhex(d);
    }
    //For MD5 encryption of emailId field in preOrder popup-Analytics end
    $(function() {
        initNotification();
    });

})(jQuery);